import { css } from 'aphrodite/no-important';
import { useScrollToTopOnMount } from 'hooks';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { style } from './style';

export const Closed: FC = () => {
  useScrollToTopOnMount();

  const cmsData = useSelector((state: RootState) => state.widget.cms.text.closed);
  const headerData = useSelector((state: RootState) => state.widget.cms.text.header);
  const { logo_url: logoUrl, header_text: copy } = headerData;

  const styles = style({
    mobileHeroImage: cmsData.hero_image_url_mobile,
    desktopHeroImage: cmsData.hero_image_url_desktop,
  });

  return (
    <main className={css(styles.main)}>
      <header className={css(styles.heroImageContainer)}>
        <div className={css(styles.header)}>
          <div className={`${css(styles.brandingContainer)}`}>
            <figure className={css(styles.logo)}>
              <img src={logoUrl} alt='TSMC Logo' />
            </figure>
            <p className={css(styles.copy)} dangerouslySetInnerHTML={{ __html: copy }} />
          </div>
        </div>

        {(!!cmsData.closed_text || !!cmsData.closed_text_secondary) && (
          <div className={css(styles.closedTextContainer)}>
            {cmsData.closed_text && (
              <h2 className={css(styles.closedText)} dangerouslySetInnerHTML={{ __html: cmsData.closed_text }}></h2>
            )}
            {cmsData.closed_text_secondary && (
              <p
                className={css(styles.closedTextSecondary)}
                dangerouslySetInnerHTML={{ __html: cmsData.closed_text_secondary }}></p>
            )}
          </div>
        )}
      </header>
    </main>
  );
};
